export default __webpack_public_path__ + "static/media/misc-closetB-2048w.cc5eb11a.webp";